import utils from "./utils";
import md5 from "blueimp-md5"

export const handleGeolocalization = (label) => {
    window.dataLayer.push({
        'event': 'faGeolocalization',
        'eventLabel': label
    });
}

export const handleLocationInteraction = (label) => {
    window.dataLayer.push({
        'event': 'faLocationInteraction',
        'eventLabel': label
    });
}

export const handleMapOpening = (label) => {
    window.dataLayer.push({
        'event': 'faMapOpening',
        'eventLabel': label
    });
}

export const handleLocationSearch = (searchquery) => {
    window.dataLayer.push({
        'event': 'faLocationSearch',
        'eventLabel': searchquery
    });
}

export const handleCap = (cap) => {
  window.dataLayer.push({
    'capFiliale': cap
  });
}

export const trackRedirection = (tipo_redirect) => {
  window.dataLayer.push({
    'event': 'faRedirection',
    'faRedirect': tipo_redirect
  });
}

export const trackClinkCTAShow = () => {
  window.dataLayer.push({
    'event': 'impression_cta',
    'eventCategory': 'Fissa Appuntamento',
    'eventAction': 'Compass Link',
    'eventLabel': 'Impressions'
  });
}

export const trackClinkCTAClick = (val) => {
  window.dataLayer.push({
    'event': 'click_clink',
    'eventCategory': 'Fissa Appuntamento',
    'eventAction': 'Compass Link',
    'eventLabel': ('Click - ' + val)
  });
}


export const trackPageView = (page_name) => {
  let gState = utils.getState();
  if (gState.app_loaded) {
    let funnel = 'filiale';
    if (gState.prodotto == -2) {
      funnel = 'telefonico';
    }
    window.dataLayer.push({
      'event': 'customPageview',
      'origineFunnel': funnel
    });
  }
}

export const startDigitalAssistant = (page_name) => {
  /*window.dataLayer.push({
    'event': 'compass-assistant-start'
  });*/
  //window.dispatchEvent(new CustomEvent('compass-assistant-start'));
  /*let ce = document.createEvent('CustomEvent');
  ce.initCustomEvent('compass-assistant-start', false, false, {});
  window.dispatchEvent(ce);*/
}

export const stopDigitalAssistant = (page_name) => {
  /*window.dataLayer.push({
    'event': 'compass-assistant-stop'
  });*/
  //window.dispatchEvent(new CustomEvent('compass-assistant-stop'));
  /*let ce = document.createEvent('CustomEvent');
  ce.initCustomEvent('compass-assistant-stop', false, false, {});
  window.dispatchEvent(ce);*/
}

export const trackCFRiconosciuto = () => {
  window.dataLayer.push({
    'event': 'customPageview',
    'virtualPageURL': '/fissa-appuntamento/dati-personali-riconosciuto'
  });
}

export const trackOppId = (OppId) => {
    window.dataLayer.push({
        'oppID': OppId
    });

    /*let lab_string = isModifica ? 'appuntamento_modificato' : 'appuntamento_caricato';
    window.dataLayer.push({
        'event': 'evento',
        'eventCategory': 'fissappuntamento',
        'eventAction': 'conferma',
        'eventLabel': lab_string,
        'codiceOpportunita': OppId
    })*/
}

export const trackContactID = (cid) => {
    window.dataLayer.push({
        'userId': cid
    });
}

export const handleFaFunnel = (label) => {
    window.dataLayer.push({
        'event': 'faFunnel',
        'funnel': label
    });
}

export const handleCalcCfOpen = () => {
  window.dataLayer.push({
    'event': 'click_calcolo_cf',
    'event_name': 'fa_click_calcolo_cf',
    'eventCategory': 'Fissa Appuntamento',
    'eventAction': 'Widget CF', 
    'eventLabel': 'Click'
  });
}

export const handleCalcCfDone = () => {
  window.dataLayer.push({
    'event': 'submit_calcolo_cf',
    'event_name': 'fa_submit_calcolo_cf',
    'eventCategory': 'Fissa Appuntamento',
    'eventAction': 'Widget CF', 
    'eventLabel': 'Submit'
  });
}

export const trackEmail = (email) => {
  window.dataLayer.push({
    'm_mdx': md5(email)
  });
}

export const trackCF = (cf) => {
  window.dataLayer.push({
    'c_mdx': md5(cf)
  });
}

export const trackPhone = (tel) => {
  window.dataLayer.push({
    'p_mdx': md5(tel)
  });
}


// WEBPACK FOOTER //
// ./src/modules/datalayer.js